import { z } from 'zod';

export const generateSocialVideoV1RequestSchema = z.object({
  clipIds: z.array(z.number()).optional(),
});

export type IGenerateSocialVideoV1Request = z.infer<typeof generateSocialVideoV1RequestSchema>;
